import { MantineMenu } from '@dealstack/frontend/shared/components/MantineMenu/MantineMenu';
import { Z_INDEX } from '@dealstack/frontend/shared/mechanism/styleguide/GlobalStyling';
import { TEST_ELEMENT_IDS, makeComplexDataTestId } from '@dealstack/shared/tests/testElementIds';
import { Text } from '@mantine/core';
import { memo } from 'react';
import { NavLink } from 'react-router-dom';
import { MantineMenuItemProps } from './MantineMenu/MantineMenu.types';

interface Props {
	targetHref: string;
	targetTitle?: string;
	items?: MantineMenuItemProps[];
	bottomSectionItems?: MantineMenuItemProps[];
	breadcrumbType?: 'programme' | 'deal' | 'documents';
}

const BreadcrumbDropdown = ({
	targetHref,
	targetTitle,
	items = [],
	bottomSectionItems = [],
	breadcrumbType,
}: Props) => {
	return (
		<MantineMenu
			position="bottom-start"
			items={items}
			bottomSectionItems={bottomSectionItems}
			menuProps={{
				zIndex: Z_INDEX.GLOBAL_MENU,
			}}
			dataTestId={makeComplexDataTestId(TEST_ELEMENT_IDS.BREADCRUMB_DROPDOWN, breadcrumbType)}
			targetContent={
				<NavLink to={targetHref} onClick={(ev) => ev.stopPropagation()}>
					<Text
						variant="h6"
						fw={600}
						sx={() => ({
							':hover': {
								textDecoration: 'underline',
							},
						})}
						lineClamp={1}
						truncate
						title={targetTitle}
					>
						{targetTitle}
					</Text>
				</NavLink>
			}
		/>
	);
};
const _BreadcrumbDropdownExport = memo(BreadcrumbDropdown);

export { _BreadcrumbDropdownExport as BreadcrumbDropdown };
